import { t } from '@lingui/core/macro';
import { PendingRecipient } from './PendingRecipient';
import { RecipientsAccordion } from '../../../RecipientsAccordion';
export function UnorderedSignerRecipients(props) {
    const { recipients } = props;
    if (!recipients.length) {
        return null;
    }
    return (<RecipientsAccordion hideTooManyItems title={t({ message: 'Signing parties', comment: 'Label for signing parties' })}>
      {recipients.map((recipient) => (<PendingRecipient key={recipient.id} recipient={recipient} isOnlyRecipient={recipients.length === 1}/>))}
    </RecipientsAccordion>);
}
